"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));
var _meta = require("../_utils/meta");
var _LinkWrapper = _interopRequireDefault(require("../RelatedContentCard/LinkWrapper"));
var _RelatedContentCard = require("../RelatedContentCard");
var _commonUtils = require("@sial/common-utils");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {},
    heading: {
      display: 'block',
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightBold,
      lineHeight: '1.2em',
      margin: '24px 0 16px',
      textTransform: 'uppercase',
      '.aem-Grid--default--3 &, .aem-Grid--default--4 &': {
        fontSize: theme.typography.pxToRem(18),
        textTransform: 'initial'
      }
    },
    container: {
      width: 'auto',
      margin: theme.spacing(0, -4)
    },
    item: (0, _defineProperty2.default)({
      padding: theme.spacing(2, 4, 4, 4),
      flexBasis: '100%'
    }, theme.breakpoints.up('md'), {
      padding: theme.spacing(3, 6, 3, 4),
      marginBottom: theme.spacing(10),
      flexBasis: '25%',
      '.aem-Grid--default--3 &, .aem-Grid--default--4 &': {
        flexBasis: '100%'
      }
    }),
    ctaLink: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.typography.pxToRem(14),
      textTransform: 'capitalize'
    },
    icon: {
      verticalAlign: 'bottom'
    }
  };
});
var RelatedCategoriesEditConfig = {
  emptyLabel: 'Related Content Links',
  isEmpty: function isEmpty(props) {
    if (typeof props.categories !== 'undefined' && props.categories.length > 0) {
      return false;
    } else {
      return true;
    }
  }
};
var RelatedCategories = function RelatedCategories(props) {
  var title = props.title,
    _props$stackCards = props.stackCards,
    stackCards = _props$stackCards === void 0 ? false : _props$stackCards,
    _props$categories = props.categories,
    categories = _props$categories === void 0 ? [] : _props$categories,
    ctaTitle = props.ctaTitle,
    ctaLink = props.ctaLink,
    anchorId = props.anchorId;
  var isAemEditMode = (0, _meta.getWcmmode)() === 'edit';
  var classes = useStyles(stackCards);
  var isGTMEnabled = function isGTMEnabled() {
    var _window;
    return typeof window !== 'undefined' && ((_window = window) === null || _window === void 0 ? void 0 : _window.dataLayer);
  };
  var action = typeof window !== 'undefined' ? "".concat(window.location.origin).concat(ctaLink) : _commonUtils.EventValues.NotAvailable;
  var label = typeof window !== 'undefined' ? "".concat(ctaTitle, " | ").concat(window.location.href) : _commonUtils.EventValues.NotAvailable;
  var trackViewMoreClickEventGA = function trackViewMoreClickEventGA() {
    if (!isGTMEnabled) return;
    _commonUtils.Analytics.sendGTMEvent({
      eventType: _commonUtils.GTMEventTypes.AnalyticsEvent,
      payload: {
        eventCategory: _commonUtils.GTMEventCategory.InsiteLinkClick.toLowerCase(),
        eventAction: action.toLowerCase(),
        eventLabel: label.toLowerCase(),
        eventInteractionType: 0
      }
    });
  };
  if (RelatedCategoriesEditConfig.isEmpty(props) && !isAemEditMode) {
    return null;
  }
  return __jsx("div", {
    id: anchorId,
    className: "aem-ms-cmp aem-ms-grid-view aem-ms-related-categories ".concat(classes.wrapper)
  }, title && __jsx(_core.Typography, {
    component: "strong",
    className: classes.heading,
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), __jsx("ul", {
    className: classes.container
  }, categories && categories.map(function (category, index) {
    return __jsx("li", {
      className: classes.item,
      key: "".concat(index)
    }, __jsx(_RelatedContentCard.RelatedContentCard, {
      url: category.categoryUrl,
      title: category.categoryTitle,
      maxTitleLines: 2,
      thumbnail: category.thumbnail,
      externalUrl: category.externalUrl
    }));
  }), ctaTitle && ctaLink && __jsx("li", null, __jsx(_LinkWrapper.default, {
    href: ctaLink,
    handleLinkClick: trackViewMoreClickEventGA
  }, __jsx(_core.Typography, {
    className: classes.ctaLink,
    component: "span",
    dangerouslySetInnerHTML: {
      __html: ctaTitle
    }
  }), __jsx(_ChevronRight.default, {
    className: classes.icon
  })))));
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/relatedcontentlinks')(RelatedCategories, RelatedCategoriesEditConfig);
exports.default = _default;